import React from 'react';
import { Immutable } from 'nuclear-js';

import SubGoal from './sub-goal';
import IAUtils from '../utils';
import CommonStrings from 'resources/common-strings';

export function getGoalsToShow(
    learningStatementsForGoal,
    goal,
    selectedGoals,
    studentInfo,
    selectedSubGoal,
    selectedSubGoalTopic,
    groupBy,
    hideLearningStatements,
    strengthFilter,
    standardTypes,
    batchInfo,
    isSingleStudentMode
) {
    const ritRanges = IAUtils.findRitRanges(goal.get('score'));

    const orderedStatements =
        learningStatementsForGoal != null
            ? learningStatementsForGoal.sortBy((statements, subGoalName) => subGoalName)
            : Immutable.OrderedMap();

    const subGoals = [
        <h1 key={goal.get('goalkey') + '-' + goal.get('name')} className="text-blue-light goal">
            {goal.get('name')}
            <div key="border" className="print-only goal-score-and-error">
                <span key={'score-tab-' + goal.get('goalkey')} className="score">
                    {goal.get('score')}
                </span>
                <span key={'standardError-' + goal.get('goalkey')} className="standard-error">
                    {CommonStrings.plusOrMinus + CommonStrings.space + goal.get('standardError')}
                </span>
            </div>
        </h1>,
    ];
    if (orderedStatements.size > 0) {
        orderedStatements.forEach((learningStatementsForSubgoal, subGoalName) => {
            const lsBySubgoal =
                learningStatementsForSubgoal != null && learningStatementsForSubgoal.size > 0
                    ? learningStatementsForSubgoal
                    : null;
            const firstlsBySubgoal = lsBySubgoal != null && lsBySubgoal.size > 0 ? lsBySubgoal.first().first() : null;
            const subgoalId = firstlsBySubgoal == null ? '' : firstlsBySubgoal.get('subgoalId');
            const subgoalName = firstlsBySubgoal == null ? '' : firstlsBySubgoal.get('subgoalName');
            const id = 'sub-goal-' + subgoalId;
            const key = 'sub-goal-' + subgoalId;
            subGoals.push(
                SubGoal.getSubGoalsToShow(
                    id,
                    key,
                    subgoalName,
                    learningStatementsForSubgoal,
                    studentInfo,
                    ritRanges,
                    selectedSubGoalTopic,
                    groupBy,
                    hideLearningStatements,
                    strengthFilter,
                    standardTypes,
                    batchInfo,
                    isSingleStudentMode
                )
            );
        });
    } else {
        // There are no learning statements available for this student with the current filters applied.
        // Show a message to the user signifying this fact.
        const id = 'no-learning-statements';
        const noLearningStatements = (
            <div id={`${id}`} className="grouping-container">
                <p className="no-learning-statements">
                    {CommonStrings.noLearningStatementsForStudentWithFiltersApplied}
                </p>
            </div>
        );
        subGoals.push(noLearningStatements);
    }
    return subGoals;
}

export default {
    getGoalsToShow,
};
